import { object } from "klassified";

/**
 * Route match result are used as the answer of matching a url against a route.
 *
 * @param {object} [spec]
 * @param {object} spec.url Matched URL
 * @param {object} spec.route Matched Route
 * @param {object} spec.values Hash with matched parameter names as keys and matching url segment values.
 *
 * @returns {routeMatchResult}
 */
const routeMatchResult = object.subclass((that, my) => {
	let url;
	let route;
	let urlParameters;
	let routeParameters;
	let parameters;

	my.initialize = function (spec) {
		my.super(spec);
		url = spec.url;
		route = spec.route;

		urlParameters = (url && url.getQuery && url.getQuery()) || {};
		routeParameters = spec.values || {};
		parameters = mergeParameters(routeParameters, urlParameters);
	};

	//
	// Public
	//

	/**
	 * Matched route
	 *
	 * @returns {route}
	 */
	that.getRoute = function () {
		return route;
	};

	/**
	 * Matched URL
	 *
	 * @returns {url}
	 */
	that.getUrl = function () {
		return url;
	};

	/**
	 * Answers true if route match URL
	 *
	 * @returns {boolean}
	 */
	that.isMatch = function () {
		return true;
	};

	/**
	 * Values for parameters in route
	 *
	 * @returns {object}
	 */
	that.getRouteParameters = function () {
		return routeParameters;
	};

	/**
	 * Values for parameters in query
	 *
	 * @returns {object}
	 */
	that.getQueryParameters = function () {
		return url.getQuery();
	};

	/**
	 * All matched parameters
	 *
	 * @returns {object}
	 */
	that.getParameters = function () {
		return parameters;
	};

	/**
	 * Constructs an array with all parameters in same order as in route pattern with
	 * query parameter as the last value.
	 *
	 * @returns {Array}
	 */
	that.getActionArguments = function () {
		const actionArguments = Object.keys(routeParameters).map(
			(parameterName) => routeParameters[parameterName],
		);
		actionArguments.push(url.getQuery());
		return actionArguments;
	};

	//
	// Private
	//

	// eslint-disable-next-line no-shadow -- we should fix that later
	function mergeParameters(routeParameters, queryParameters) {
		const allValues = {};

		// Fill with route parameters
		for (const parameterName in routeParameters) {
			if (
				Object.prototype.hasOwnProperty.call(
					routeParameters,
					parameterName,
				)
			) {
				allValues[parameterName] = routeParameters[parameterName];
			}
		}

		// Fill with query parameters
		for (const queryParameterName in queryParameters) {
			if (
				Object.prototype.hasOwnProperty.call(
					queryParameters,
					queryParameterName,
				)
			) {
				allValues[queryParameterName] =
					queryParameters[queryParameterName];
			}
		}

		return allValues;
	}
});

routeMatchResult.class((that) => {
	/**
	 * Result to use when match does not match url
	 */
	that.routeNoMatchResult = (function () {
		/** @typedef {routeMatchResult} routeNoMatchResult */
		const instance = that();

		instance.isMatch = function () {
			return false;
		};

		return instance;
	})();
});

export default routeMatchResult;
